<dx-popup
    width="30%"
    height="45%"
    [title]="popupTitle"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onPopupHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form #notesEditorForm width="100%" height="100%" [colCount]="1" labelLocation="top">
                        <dxi-item [isRequired]="!!actionResult.reasonRequiredForAction">
                            <dxo-label text="Board Approval Note"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area [height]="90" [(value)]="actionParameter.notes"></dx-text-area>
                            </div>
                        </dxi-item>
                        <dxi-item itemType="group" [visible]="!!actionResult.allowResponseToOwner">
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Response To Owner"></dxo-label>
                                <div *dxTemplate>
                                    <small>(these notes will be used in correspondence with owner)</small>
                                </div>
                            </dxi-item>

                            <dxi-item [isRequired]="!!actionResult.allowResponseToOwner">
                                <dxo-label text="Response To Owner" [visible]="false"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-area
                                        [height]="90"
                                        [(value)]="actionParameter.responseToOwner"
                                    ></dx-text-area>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Ok"
                                    useSubmitBehavior="true"
                                    [icon]="iconCheck"
                                    (onClick)="onOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
